import type { NearbyOfficeOption } from "./types/nearby-office-option";
import type { NearbyOrganization } from "./types/nearby-organization";

import { getNearbyOrganizationName } from "./get-nearby-organization-name";

function mapNearbyOrganizationsToOfficeOptions(
  organizations: NearbyOrganization[],
): NearbyOfficeOption[] {
  const options = organizations.flatMap((organization) => {
    const locationName = getNearbyOrganizationName(organization);

    return organization.offices
      .filter((office) => Boolean(office.postalCode))
      .map((office, officeIndex) => ({
        address: {
          city: office.city,
          postalCode: office.postalCode,
          stateProvince: office.stateProvince,
        },
        locationName,
        officeID: organization.number,
        optionId: `${organization.number}-${officeIndex}-${office.postalCode}`,
      }));
  });

  const seen = new Set<string>();
  return options.filter((option) => {
    const key = `${option.locationName}:${option.address.postalCode}`;
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
}

export { mapNearbyOrganizationsToOfficeOptions };
